import React, { useMemo } from 'react'
import { DataTable } from 'react-native-paper'
import { Text, View } from 'react-native'
import { flattenEntity } from '../../helpers/entity'
import { viewMode } from '../EntityAddComponent'
import { IsGenericEntityIdentifier } from '../../components/GridItemButton'
import { DataTableCell } from './DataTableCell'

const DataTableEntityRow = React.memo(
  ({
    item,
    index: rowIndex,
    reportEntity,
    showLabelInTable,
    showAssigneeInTable,
    showApprovalsInTable,
    sortedColumnHeaders,
    cellStyle,
    canNavigate,
    shouldSplit,
    splitviewNavigate,
    linkTo
  }) => {
    const flattened = useMemo(() => flattenEntity(item, true, reportEntity), [
      item,
      reportEntity
    ])

    const nonFieldColumnsAlarmColorStyle = flattened._alarmStateColors?.length
      ? { color: flattened._alarmStateColors[0] }
      : null

    return (
      <DataTable.Row
        key={rowIndex}
        style={{
          backgroundColor: rowIndex % 2 ? 'transparent' : '#f1f1f1'
        }}
        onPress={() =>
          canNavigate
            ? shouldSplit
              ? splitviewNavigate(item, viewMode)
              : linkTo(flattened.uri)
            : undefined
        }
      >
        {showLabelInTable && (
          <DataTable.Cell key={'label'} style={cellStyle}>
            <Text style={nonFieldColumnsAlarmColorStyle}>
              {flattened.display_name}
            </Text>{' '}
            {!item.tenant_id && <IsGenericEntityIdentifier />}
          </DataTable.Cell>
        )}
        {showAssigneeInTable && (
          <DataTable.Cell key={'assignee'} style={cellStyle}>
            <Text style={nonFieldColumnsAlarmColorStyle}>
              {flattened.assignees}
            </Text>
          </DataTable.Cell>
        )}
        {showApprovalsInTable && (
          <DataTable.Cell
            key={'approvals'}
            style={[
              cellStyle,
              {
                flex: 1,
                justifyContent: 'flex-start'
              }
            ]}
          >
            <View
              style={{
                flex: 1,
                width: '100%'
              }}
            >
              {!!flattened?.data_approved &&
                (flattened?.data_approved ?? [])?.map((el, index) => {
                  return (
                    <View
                      key={index}
                      style={{
                        width: '100%',
                        flex: 1
                      }}
                    >
                      <Text>{el}</Text>
                    </View>
                  )
                })}
            </View>
          </DataTable.Cell>
        )}
        {sortedColumnHeaders?.map((columnHeaderField, columnIndex) => (
          <DataTableCell
            key={columnIndex}
            columnHeaderField={columnHeaderField}
            entity={flattened}
            cellStyle={cellStyle}
          />
        ))}
      </DataTable.Row>
    )
  }
)

export default DataTableEntityRow
